import metadataApproverMutations from "./mutations.js";
import metadataApproverActions from "./actions.js";
import metadataApproverGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {

    };
  },
  mutations: metadataApproverMutations,
  actions: metadataApproverActions,
  getters: metadataApproverGetters,
};
